import React from 'react';

import { TaskCard } from '@app/shared/ui/molecules/Tasks';
import { TaskModel } from '@app/store/slices/tasks/taskTypes';

type Props = {
  tasks: TaskModel[];
  isDisabledAction: boolean;
  onClickAction: (task: TaskModel, event: React.MouseEvent<HTMLElement>) => void;
};

export function TasksList({ tasks, onClickAction, isDisabledAction }: Props) {
  return (
    <ul className="space-y-4">
      {tasks.map((task) => (
        <li key={task.id}>
          <TaskCard task={task} onClick={onClickAction} isBtnDisabled={isDisabledAction} />
        </li>
      ))}
    </ul>
  );
}
